module.exports = __webpack_public_path__ + "static/img/school3.1b5f938.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/school3.jpg
// module id = x5IE
// module chunks = 1